export function dunno() {
  const dunnos = ['🤷', '🤷‍♀️', '🤷‍♂️', '🤔', '💁‍♂️', '💁‍♀️']
  const i = Math.floor(Math.random() * dunnos.length)
  return dunnos[i]
}
